import type { ReactNode } from "react";
import { Avatar } from "../ui/Avatar";

/**
 * A room as one line of a desktop side rail (Figma "RoomLine"): logo, name, a
 * one or two line subtitle, and an optional trailing action (Follow).
 *
 * The line is a link to the room. The action sits beside it rather than inside
 * it, so its click never opens the room.
 */
function DesktopRoomLine({
  name,
  logoUrl,
  nameBadge,
  subtitle,
  action,
  onClick,
}: {
  name: string;
  /** Beside the name: the LIVE pill of a room whose congress is on, or none */
  nameBadge: ReactNode;
  logoUrl: string | null;
  subtitle: string;
  action: ReactNode;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <div className="flex w-full items-center gap-2.5">
      <button
        type="button"
        onClick={onClick}
        className="flex min-w-0 flex-1 cursor-pointer items-start gap-2.5 text-left"
      >
        {logoUrl === null ? (
          <Avatar
            variant="initials"
            initials={name.charAt(0)}
            size="md"
            badge={null}
          />
        ) : (
          <Avatar
            variant="image"
            src={logoUrl}
            alt=""
            imageFit="scale-down"
            size="md"
            badge={null}
          />
        )}
        <span className="flex min-w-0 flex-1 flex-col gap-px">
          <span className="flex min-w-0 items-center gap-1.5">
            <span className="text-footnote font-medium text-ds-slate-900 hover:underline">
              {name}
            </span>
            {nameBadge}
          </span>
          <span className="line-clamp-2 text-caption text-ds-slate-500">
            {subtitle}
          </span>
        </span>
      </button>
      {action}
    </div>
  );
}

export { DesktopRoomLine };
